<div id="todo" class="page-layout carded left-sidebar inner-scroll">
    <!-- SIDEBAR -->
    <fuse-sidebar class="sidebar" name="customer-details-sidebar" position="left" lockedOpen="gt-md">
        <customer-details-sidebar [user]="user"></customer-details-sidebar>
    </fuse-sidebar>
    <!-- / SIDEBAR -->

    <!-- CENTER -->
    <div class="center">
        <div class="content-card" style="overflow-y: scroll;">
            <!-- CONTENT -->
            <div id="ngx-datatable" class="page-layout simple fullwidth docs">
                <div class="content p-24">
                    <ngx-datatable
                        #table
                        class="material"
                        [rows]="rows"
                        [loadingIndicator]="loadingIndicator"
                        [columnMode]="'force'"
                        [headerHeight]="48"
                        [footerHeight]="56"
                        [rowHeight]="'auto'"
                        [scrollbarH]="true"
                        [reorderable]="reorderable"
                        [selectionType]="'checkbox'"
                        [externalPaging]="true"
                        [count]="page.totalElements"
                        [offset]="page.pageNumber"
                        [limit]="page.size"
                        (page)="setPage($event)">


                        <ngx-datatable-column name="{{'Date' | translate}}" prop="createdAt">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.createdAt | date:'dd.MM.yyyy HH:mm':'UTC+2' : 'pl'}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Channel' | translate}}" prop="channel">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                               {{row.channel}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Destination' | translate}}" prop="recipientAddress">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.recipientAddress}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Topic' | translate}}" prop="topic">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.topic}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Message' | translate}}" prop="message">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.message}}
                            </ng-template>
                        </ngx-datatable-column>

                    </ngx-datatable>
                </div>
            </div>
        </div>
    </div>
</div>
